<div class="main-container">
  <ng-container [dbResolve]="kioskResolveBundle">
    @if (firstPairOfMeetingRoomScheduleEntries$ | async; as firstEntryPair) {
      @if (firstEntryPair.length > 0) {
        <div class="db-container">
          <div
            class="availability-marker"
            [class.free]="
              firstEntryPair[0]?.status === MeetingRoomKioskStatus.FREE
            "
            [class.occupied]="
              firstEntryPair[0]?.status === MeetingRoomKioskStatus.OCCUPIED
            "
            [class.checkIn]="
              firstEntryPair[0]?.status === MeetingRoomKioskStatus.CHECK_IN
            "
          ></div>
          @if (meetingRoomData$ | async; as meetingRoomData) {
            <div class="page-container">
              <div class="controls-row">
                <div class="side">
                  <db-button
                    class="kiosk-high-button info-button"
                    width="fit-content"
                    icon="pi pi-info-circle"
                    severity="secondary"
                    (click)="roomInformationVisible = true"
                    i18n="@@meeting-rooms-kiosk|room-info-button"
                  >
                    Show room info
                  </db-button>

                  @if (platform === PlatformEnum.WEB && !isFullScreen) {
                    <db-button
                      class="kiosk-high-button info-button"
                      width="fit-content"
                      icon="pi pi-window-maximize"
                      severity="secondary"
                      (click)="enterFullScreen()"
                      i18n="@@meeting-rooms-kiosk|full-screen-button"
                    >
                      Enter full screen
                    </db-button>
                  }
                </div>
                <div class="side date-container">
                  <h2 class="time">{{ currentClockString }}</h2>
                  <span class="normal-text date">{{ currentDateString }}</span>
                </div>
              </div>
              <div class="content-container">
                <div class="meeting-room-details-container">
                  <div class="details-container">
                    @if (meetingRoomData.imageUrl) {
                      <div class="image-container">
                        <img
                          [src]="meetingRoomData.imageUrl"
                          alt="meeting room"
                        />
                      </div>
                    }
                    <div class="room-info">
                      <div class="title-container">
                        <span
                          class="title inline-block whitespace-nowrap overflow-hidden text-ellipsis"
                          >{{ meetingRoomData.name }}</span
                        >
                        <div
                          class="availability-marker-badge min-w-fit"
                          [class.free]="
                            firstEntryPair[0]?.status ===
                            MeetingRoomKioskStatus.FREE
                          "
                          [class.occupied]="
                            firstEntryPair[0]?.status ===
                            MeetingRoomKioskStatus.OCCUPIED
                          "
                          [class.checkIn]="
                            firstEntryPair[0]?.status ===
                            MeetingRoomKioskStatus.CHECK_IN
                          "
                        >
                          {{ statusToLabelMap[firstEntryPair[0]?.status!] }}
                        </div>
                      </div>
                      <div class="availability-info-container">
                        <h2 class="meeting-title flex items-center">
                          @if (
                            firstEntryPair[0]?.status !==
                            MeetingRoomKioskStatus.FREE
                          ) {
                            <span class="line-clamp-1">
                              {{ firstEntryPair[0]?.title }}
                            </span>
                          } @else {
                            @if ((isAvailableUntilEOD$ | async) === false) {
                              <ng-container
                                i18n="
                                  @@meeting-rooms-kiosk|available-until-time"
                              >
                                Available until
                                {{
                                  firstEntryPair[0]?.endTime!
                                    | exec: formatTimeString
                                }}
                              </ng-container>
                            } @else {
                              <ng-container
                                i18n="
                                  @@meeting-rooms-kiosk|available-until-end-of-day"
                              >
                                Available until end of day
                              </ng-container>
                            }
                          }
                        </h2>
                        @if (
                          firstEntryPair[0]?.status !==
                          MeetingRoomKioskStatus.FREE
                        ) {
                          <div class="meeting-organiser">
                            @if (firstEntryPair[0]?.organiser) {
                              <db-user-info
                                [userNameClasses]="['small-text']"
                                [avatarSize]="'mini-no-border'"
                                [userInfo]="firstEntryPair[0]?.organiser!"
                                [whiteText]="true"
                              />
                              <div class="separator"></div>
                            }
                            <h4 class="event-time">
                              {{
                                firstEntryPair[0]?.startTime!
                                  | exec: formatTimeString
                              }}
                              -
                              {{
                                firstEntryPair[0]?.endTime!
                                  | exec: formatTimeString
                              }}
                            </h4>
                          </div>
                        }
                      </div>
                      <div class="flex align-center text-white justify-between">
                        @if (
                          firstEntryPair[0]?.status ===
                          MeetingRoomKioskStatus.FREE
                        ) {
                          <db-button
                            class="kiosk-high-button"
                            severity="white"
                            (click)="onInitBookCurrent()"
                            i18n="@@meeting-rooms-kiosk|book-now-button"
                          >
                            Book now
                          </db-button>
                        }
                        @if (
                          firstEntryPair[0]?.status ===
                          MeetingRoomKioskStatus.OCCUPIED
                        ) {
                          <db-button
                            class="kiosk-high-button"
                            severity="white"
                            [isLoading]="isEndingBookingEarly"
                            (click)="onEndMeetingCurrent()"
                            i18n="@@meeting-rooms-kiosk|end-now-button"
                          >
                            End meeting
                          </db-button>
                        }
                        @if (
                          firstEntryPair[0]?.status ===
                          MeetingRoomKioskStatus.CHECK_IN
                        ) {
                          <db-button
                            class="kiosk-high-button"
                            severity="white"
                            [isLoading]="isCheckingBookingIn"
                            (click)="onCheckInMeetingCurrent()"
                            i18n="@@meeting-rooms-kiosk|check-in-button"
                          >
                            Check in
                          </db-button>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="branding-container">
                    <span i18n="@@meeting-rooms-kiosk|powered-by"
                      >Powered by
                    </span>
                    <img
                      width=""
                      src="/assets/images/kiosk-deskbird-logo.svg"
                      alt="DB logo"
                    />
                  </div>
                </div>
                <div class="schedule">
                  <div class="hours-container">
                    @for (hour of hours; track hour) {
                      <div class="hour">
                        <span class="small-text-bold"
                          >{{ hour | exec: formatHourString }}
                        </span>
                      </div>
                    }
                  </div>
                  <div class="events-container">
                    <!-- Current time indicator -->
                    <div
                      class="current-time-indicator"
                      [style.top.px]="currentTimeIndicatorPosition"
                    >
                      <div
                        class="time-line"
                        [attr.data-time]="currentTimeIndicatorString"
                      ></div>
                    </div>

                    @for (
                      scheduleEvent of meetingRoomScheduleData$ | async;
                      track scheduleEvent.id;
                      let idx = $index
                    ) {
                      <div
                        class="event-wrapper"
                        [style.top.px]="
                          calculateEventTopPosition(scheduleEvent)
                        "
                        [style.height.px]="
                          calculateWrapperHeight(scheduleEvent)
                        "
                        [style.display]="
                          calculateWrapperHeight(scheduleEvent) > 0
                            ? 'block'
                            : 'none'
                        "
                        [class.current-event]="isCurrentEvent(scheduleEvent)"
                      >
                        <div
                          class="event"
                          [class.now]="isCurrentEvent(scheduleEvent)"
                          [class.free]="
                            isCurrentEvent(scheduleEvent) &&
                            scheduleEvent.status === MeetingRoomKioskStatus.FREE
                          "
                          [class.occupied]="
                            isCurrentEvent(scheduleEvent) &&
                            scheduleEvent.status ===
                              MeetingRoomKioskStatus.OCCUPIED
                          "
                          [class.checkIn]="
                            isCurrentEvent(scheduleEvent) &&
                            scheduleEvent.status ===
                              MeetingRoomKioskStatus.CHECK_IN
                          "
                          [class.inactive-slot]="!isCurrentEvent(scheduleEvent)"
                          [class.inactive-free]="
                            !isCurrentEvent(scheduleEvent) &&
                            scheduleEvent.status ===
                              MeetingRoomKioskStatus.FREE &&
                            !isPastSlot(scheduleEvent)
                          "
                          [class.inactive-occupied]="
                            !isCurrentEvent(scheduleEvent) &&
                            scheduleEvent.status ===
                              MeetingRoomKioskStatus.OCCUPIED
                          "
                          [class.inactive-checkIn]="
                            !isCurrentEvent(scheduleEvent) &&
                            scheduleEvent.status ===
                              MeetingRoomKioskStatus.CHECK_IN
                          "
                          [class.past-slot]="isPastSlot(scheduleEvent)"
                          [class.sizeNone]="
                            scheduleEvent.size === KioskScheduleEntrySize.NONE
                          "
                          [class.sizeMini]="
                            scheduleEvent.size === KioskScheduleEntrySize.MINI
                          "
                          [class.sizeXSmall]="
                            scheduleEvent.size ===
                            KioskScheduleEntrySize.X_SMALL
                          "
                          [class.sizeSmall]="
                            scheduleEvent.size === KioskScheduleEntrySize.SMALL
                          "
                          [class.sizeMedium]="
                            scheduleEvent.size === KioskScheduleEntrySize.MEDIUM
                          "
                          [class.sizeLarge]="
                            scheduleEvent.size === KioskScheduleEntrySize.LARGE
                          "
                          (click)="handleEntryClick(scheduleEvent)"
                        >
                          @if (
                            isCurrentEvent(scheduleEvent) &&
                            scheduleEvent.duration &&
                            scheduleEvent.duration > 7
                          ) {
                            <div
                              class="current-event-banner"
                              [class.free]="
                                isCurrentEvent(scheduleEvent) &&
                                scheduleEvent.status ===
                                  MeetingRoomKioskStatus.FREE
                              "
                              [class.occupied]="
                                isCurrentEvent(scheduleEvent) &&
                                scheduleEvent.status ===
                                  MeetingRoomKioskStatus.OCCUPIED
                              "
                              [class.checkIn]="
                                isCurrentEvent(scheduleEvent) &&
                                scheduleEvent.status ===
                                  MeetingRoomKioskStatus.CHECK_IN
                              "
                            ></div>
                          }
                          <div class="event-data-container">
                            <div
                              class="event-data"
                              [ngClass]="{
                                '!flex-col !gap-0 !items-start':
                                  scheduleEvent.size ===
                                  KioskScheduleEntrySize.MEDIUM,
                              }"
                            >
                              <h3
                                class="event-title"
                                [ngClass]="{
                                  'line-clamp-1 w-full text-ellipsis overflow-hidden whitespace-nowrap !block':
                                    scheduleEvent.size ===
                                    KioskScheduleEntrySize.MEDIUM,
                                }"
                              >
                                @if (
                                  isCurrentEvent(scheduleEvent) &&
                                  scheduleEvent.status ===
                                    MeetingRoomKioskStatus.FREE
                                ) {
                                  <span
                                    i18n="
                                      @@meeting-rooms-kiosk|slot-free-now-label"
                                    >Free now</span
                                  >
                                } @else {
                                  {{ scheduleEvent.title }}
                                }
                              </h3>
                              <div class="row justify-between items-center">
                                <div class="flex items-center justify-between">
                                  @if (
                                    scheduleEvent.organiser &&
                                    scheduleEvent.status !==
                                      MeetingRoomKioskStatus.FREE &&
                                    !isOnSmallScreen &&
                                    scheduleEvent.size !==
                                      KioskScheduleEntrySize.MINI
                                  ) {
                                    <div class="user-info">
                                      <db-user-info
                                        [userInfo]="scheduleEvent.organiser"
                                        [whiteText]="true"
                                        [userNameClasses]="['small-text']"
                                        [avatarSize]="
                                          scheduleEvent.size ===
                                          KioskScheduleEntrySize.X_SMALL
                                            ? 'micro-no-border'
                                            : 'mini-no-border'
                                        "
                                        [onlyImage]="
                                          (scheduleEvent.organiser
                                            | exec: userNameIsTooLong) ||
                                          ((scheduleEvent.title
                                            | exec: titleIsTooLong) &&
                                            scheduleEvent.size ===
                                              KioskScheduleEntrySize.X_SMALL)
                                        "
                                      />
                                      @if (
                                        !(
                                          scheduleEvent.size ===
                                            KioskScheduleEntrySize.X_SMALL &&
                                          (scheduleEvent.title
                                            | exec: titleIsTooLong) === true
                                        )
                                      ) {
                                        <div class="separator"></div>
                                      }
                                    </div>
                                  }

                                  <h4 class="event-time">
                                    {{
                                      scheduleEvent.startTime
                                        | exec: formatTimeString
                                    }}
                                    -
                                    {{
                                      scheduleEvent.endTime
                                        | exec: formatTimeString
                                    }}
                                  </h4>
                                </div>
                                @if (scheduleEvent.hasCatering) {
                                  <div class="icon-container">
                                    <img
                                      src="/assets/icons/catering-white.svg"
                                      alt=""
                                    />
                                  </div>
                                }
                              </div>
                            </div>
                            @if (
                              scheduleEvent.status ===
                                MeetingRoomKioskStatus.FREE &&
                              !isPastSlot(scheduleEvent) &&
                              scheduleEvent.size !==
                                KioskScheduleEntrySize.NONE &&
                              scheduleEvent.size !==
                                KioskScheduleEntrySize.MINI &&
                              scheduleEvent.size !==
                                KioskScheduleEntrySize.X_SMALL &&
                              scheduleEvent.duration > 25
                            ) {
                              <div
                                class="event-controls"
                                [ngClass]="{
                                  'mt-[-8px]':
                                    scheduleEvent.size ===
                                    KioskScheduleEntrySize.SMALL,
                                }"
                              >
                                <db-button
                                  class="list-book-button kiosk-high-button"
                                  severity="white"
                                  buttonType="outlined"
                                  (click)="onInitBook(idx)"
                                >
                                  @if (isCurrentEvent(scheduleEvent)) {
                                    <ng-container
                                      i18n="
                                        @@meeting-rooms-kiosk|book-now-button"
                                    >
                                      Book now
                                    </ng-container>
                                  } @else {
                                    <ng-container
                                      i18n="@@meeting-rooms-kiosk|book-button"
                                    >
                                      Book
                                    </ng-container>
                                  }
                                </db-button>
                              </div>
                            }
                            @if (
                              !isCurrentEvent(scheduleEvent) &&
                              !isPastSlot(scheduleEvent) &&
                              scheduleEvent.size !==
                                KioskScheduleEntrySize.NONE &&
                              scheduleEvent.size !== KioskScheduleEntrySize.MINI
                            ) {
                              <div
                                class="event-controls"
                                [ngClass]="{
                                  'mt-[-8px]':
                                    scheduleEvent.size ===
                                    KioskScheduleEntrySize.SMALL,
                                }"
                              >
                                @if (
                                  scheduleEvent.status ===
                                  MeetingRoomKioskStatus.CHECK_IN
                                ) {
                                  <db-button
                                    class="list-book-button kiosk-high-button"
                                    severity="white"
                                    buttonType="outlined"
                                    [isLoading]="
                                      isCheckingBookingIn &&
                                      checkingInEventIdx === idx
                                    "
                                    (click)="
                                      checkIn(idx);
                                      $event.stopPropagation();
                                      $event.preventDefault()
                                    "
                                    i18n="
                                      @@meeting-rooms-kiosk|check-in-button-list"
                                  >
                                    Check in
                                  </db-button>
                                } @else if (
                                  scheduleEvent.status ===
                                    MeetingRoomKioskStatus.OCCUPIED &&
                                  scheduleEvent.event?.checkIn?.checkedIn ===
                                    true
                                ) {
                                  <db-button
                                    class="kiosk-high-button list-book-button checked-in-button"
                                    width="min-width-160"
                                    icon="pi pi-check"
                                    severity="secondary"
                                    [disabled]="true"
                                    [style]="{ background: '#424242' }"
                                    i18n="
                                      @@meeting-rooms-kiosk|checked-in-status"
                                  >
                                    Checked in
                                  </db-button>
                                }
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
          @if (selectedScheduleEntry) {
            <div class="dialog-container selected-entry-container z-10">
              <ng-container
                [dbResolve]="eventDetailsResolveBundle"
                [skipResolve]="
                  selectedScheduleEntry.status === MeetingRoomKioskStatus.FREE
                "
              >
                <div class="dialog selected-entry">
                  <div class="flex justify-between items-start mb-4xl">
                    <div class="flex items-center gap-lg">
                      <h4 class="text-white font-ProximaNovaBold text-2xl">
                        {{ selectedScheduleEntry.title }}
                      </h4>
                      <span
                        class="font-ProximaNovaRegular text-white flex text-sm min-w-[90px] mb-[-6px]"
                      >
                        ({{
                          selectedScheduleEntry.startTime
                            | exec: formatTimeString
                        }}
                        -
                        {{
                          selectedScheduleEntry.endTime
                            | exec: formatTimeString
                        }})
                      </span>
                    </div>
                    <db-button-icon
                      (click)="deselectEntry()"
                      icon="pi pi-times"
                    />
                  </div>
                  <div class="line-list">
                    @if (selectedScheduleEntry.organiser) {
                      <div class="line-item">
                        <img
                          class="line-item-icon"
                          height="24"
                          src="/assets/icons/user.svg"
                          alt="user"
                        />
                        <div class="line-item-description">
                          <div
                            class="line-item-title normal-text-bold"
                            i18n="
                              @@meeting-rooms-kiosk|office-event-view|organizer"
                          >
                            Organizer
                          </div>
                          <db-user-info
                            [userNameClasses]="['normal-text']"
                            [avatarSize]="'mini-no-border'"
                            [userInfo]="selectedScheduleEntry.organiser"
                            [whiteText]="true"
                          ></db-user-info>
                        </div>
                      </div>
                    }
                    @if ((eventDetails$ | async)?.attendees; as attendees) {
                      @if (attendees.length) {
                        <div class="line-item">
                          <img
                            class="line-item-icon"
                            height="24"
                            src="/assets/icons/user-double.svg"
                            alt="user-double"
                          />
                          <div class="line-item-description">
                            <div
                              class="line-item-title normal-text-bold"
                              i18n="
                                @@meeting-rooms-kiosk|office-event-view|attendees"
                            >
                              Attendees
                            </div>
                            <span class="normal-text">
                              {{ attendees.length }}
                            </span>
                          </div>
                        </div>
                      }
                    }
                    @if (
                      (eventDetails$ | async)?.serviceRequest
                        ?.requestedCategories;
                      as requestServiceCategories
                    ) {
                      @if (requestServiceCategories.length) {
                        <div class="line-item">
                          <img
                            class="line-item-icon"
                            height="24"
                            src="/assets/icons/catering.svg"
                            alt="catering"
                          />
                          <div class="line-item-description">
                            <div
                              class="line-item-title normal-text-bold"
                              i18n="@@meeting-rooms-kiosk|catering-and-services"
                            >
                              Catering & services
                            </div>
                            <span class="normal-text">
                              {{
                                requestServiceCategories
                                  | exec: getRequestedServiceCountFromCategories
                                  | i18nPlural
                                    : requestedServiceCategoriesPluralMap
                              }}
                            </span>
                          </div>
                        </div>
                      }
                    }
                    @if (
                      (eventDetails$ | async)?.description;
                      as eventDescription
                    ) {
                      <div class="line-item">
                        <img
                          class="line-item-icon"
                          height="24"
                          src="/assets/icons/info-circle.svg"
                          alt="more-details"
                        />
                        <div class="line-item-description">
                          <div
                            class="line-item-title normal-text-bold"
                            i18n="
                              @@meeting-rooms-kiosk|office-event-view|description"
                          >
                            More details
                          </div>
                          <db-html-container
                            [style]="{ color: 'white', 'font-size': '16px' }"
                            [htmlValue]="eventDescription"
                          >
                          </db-html-container>
                        </div>
                      </div>
                    }

                    <!-- Book button for free slots -->
                    @if (
                      selectedScheduleEntry.status ===
                        MeetingRoomKioskStatus.FREE &&
                      !isPastSlot(selectedScheduleEntry)
                    ) {
                      <div class="line-item">
                        <img
                          class="line-item-icon"
                          width="24"
                          height="24"
                          src="/assets/icons/calendar.svg"
                          alt="book-meeting"
                        />
                        <div class="line-item-description">
                          <div
                            class="line-item-title normal-text-bold"
                            i18n="@@meeting-rooms-kiosk|book-slot"
                          >
                            Book during this slot
                          </div>
                          <div class="mt-sm">
                            <db-button
                              class="kiosk-high-button"
                              width="fit-content"
                              severity="white"
                              (click)="onInitBookFromDetails()"
                              i18n="@@meeting-rooms-kiosk|book-button"
                            >
                              Book
                            </db-button>
                          </div>
                        </div>
                      </div>
                    }

                    <!-- Check-in section for the event details dialog -->
                    @if (
                      (selectedScheduleEntry.status ===
                        MeetingRoomKioskStatus.CHECK_IN ||
                        (selectedScheduleEntry.status ===
                          MeetingRoomKioskStatus.OCCUPIED &&
                          selectedScheduleEntry.event?.checkIn?.checkedIn ===
                            true)) &&
                      !isPastSlot(selectedScheduleEntry)
                    ) {
                      <div class="line-item">
                        <img
                          class="line-item-icon"
                          width="24"
                          height="24"
                          src="/assets/icons/checked-in.svg"
                          alt="checked-in"
                        />
                        <div class="line-item-description">
                          <div
                            class="line-item-title normal-text-bold"
                            i18n="@@meeting-rooms-kiosk|check-in-status"
                          >
                            Check in status
                          </div>
                          @if (
                            selectedScheduleEntry.status ===
                            MeetingRoomKioskStatus.CHECK_IN
                          ) {
                            <div class="mt-sm">
                              <db-button
                                class="kiosk-high-button"
                                width="fit-content"
                                severity="white"
                                [isLoading]="isCheckingBookingIn"
                                (click)="checkInSelectedEntry()"
                                i18n="@@meeting-rooms-kiosk|check-in-button"
                              >
                                Check in
                              </db-button>
                            </div>
                          } @else {
                            <div class="flex items-center mt-sm">
                              <i class="pi pi-check mr-2"></i>
                              <span
                                class="normal-text"
                                i18n="@@meeting-rooms-kiosk|checked-in-status"
                              >
                                Checked in
                              </span>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </ng-container>
            </div>
          }
          @if (meetingRoomData$ | async; as meetingRoomData) {
            @if (roomInformationVisible) {
              <div class="dialog-container room-info-container">
                <div class="dialog">
                  <div class="flex align-center justify-between">
                    <h4
                      class="text-2xl text-white mb-2xl font-ProximaNovaBold"
                      i18n="@@meeting-rooms-kiosk|room-information-title"
                    >
                      Room information
                    </h4>
                    <db-button-icon
                      (click)="roomInformationVisible = false"
                      icon="pi pi-times"
                    />
                  </div>
                  <div class="line-list">
                    <!-- TODO CONFIRM -->
                    <!-- <div class="line-item">
                    <img
                      class="line-item-icon"
                      height="24"
                      src="/assets/icons/access-lock.svg"
                      alt="lock"
                      />
                    <div class="line-item-description">
                      <div
                        class="line-item-title normal-text-bold"
                        i18n="@@meeting-rooms-kiosk|access-type"
                        >
                        Access type
                      </div>
                      <span class="normal-text">
                        {{
                        meetingRoomData.accessRules.isRestricted
                        ? restrictedRoomLabel
                        : availableRoomLabel
                        }}
                      </span>
                    </div>
                  </div> -->
                    <div class="line-item">
                      <img
                        class="line-item-icon"
                        height="24"
                        src="/assets/icons/user.svg"
                        alt="user"
                      />
                      <div class="line-item-description">
                        <div
                          class="line-item-title normal-text-bold"
                          i18n="@@meeting-rooms-kiosk|capacity"
                        >
                          Capacity
                        </div>
                        <span class="normal-text">
                          {{ meetingRoomData.capacity }}
                        </span>
                      </div>
                    </div>
                    @if (meetingRoomData.equipment?.length) {
                      <div class="line-item">
                        <img
                          class="line-item-icon"
                          height="24"
                          src="/assets/icons/info-circle.svg"
                          alt="more-details"
                        />
                        <div class="line-item-description">
                          <div
                            class="line-item-title normal-text-bold"
                            i18n="@@meeting-rooms-kiosk|equipment"
                          >
                            Equipment
                          </div>
                          <div class="equipment-chip-container">
                            @for (
                              equipmentItem of meetingRoomData.equipment;
                              track equipmentItem
                            ) {
                              <div class="equipment-chip">
                                {{ equipmentItem.title }}
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                    @if (meetingRoomData.serviceRequestsEnabled) {
                      <div class="line-item">
                        <img
                          class="line-item-icon"
                          height="24"
                          src="/assets/icons/catering.svg"
                          alt="catering"
                        />
                        <div class="line-item-description">
                          <div
                            class="line-item-title normal-text-bold"
                            i18n="@@meeting-rooms-kiosk|catering-and-services"
                          >
                            Catering & services
                          </div>
                          <span
                            class="normal-text"
                            i18n="
                              @@meeting-rooms-kiosk|meeting-room-is-available"
                          >
                            Available
                          </span>
                        </div>
                      </div>
                    }
                    @if (meetingRoomData.description) {
                      <div class="line-item">
                        <img
                          class="line-item-icon"
                          height="24"
                          src="/assets/icons/info-circle.svg"
                          alt="more-details"
                        />
                        <div class="line-item-description">
                          <div
                            class="line-item-title normal-text-bold"
                            i18n="
                              @@meeting-rooms-kiosk|office-event-view|description"
                          >
                            More details
                          </div>
                          <db-html-container
                            [style]="{ color: 'white', 'font-size': '16px' }"
                            [htmlValue]="meetingRoomData.description"
                          >
                          </db-html-container>
                        </div>
                      </div>
                    }
                    <div class="line-item">
                      <db-button
                        class="kiosk-high-button"
                        width="full-width"
                        severity="secondary"
                        (click)="exitKiosk()"
                        i18n="@@meeting-rooms-kiosk|exit-kiosk-button"
                      >
                        Disconnect
                      </db-button>
                    </div>
                  </div>
                  <!-- TODO CONFIRM -->
                  <!-- <div
                class="notice"
                *ngIf="meetingRoomData.accessRules.isRestricted"
                >
                <img
                  class="line-item-icon"
                  height="24"
                  src="/assets/icons/info-circle.svg"
                  alt="more-details"
                  />
                <span
                  class="info normal-text"
                  i18n="@@meeting-rooms-kiosk|restricted-area-notice"
                  >
                  Access to this meeting room is restricted and is not bookable
                  via kiosk. If you have access to this room, you can book via the
                  deskbird web or mobile app.
                </span>
              </div> -->
                </div>
              </div>
            }
            @if (newBookingSlot) {
              <div class="dialog-container new-booking-container">
                <div class="dialog">
                  <div class="flex align-center justify-between">
                    <h4 class="text-2xl text-white mb-4xl font-ProximaNovaBold">
                      {{ meetingRoomData.name }}
                    </h4>
                  </div>
                  <div class="form">
                    <db-meeting-room-kiosk-booking-form
                      #form
                      [slot]="newBookingSlot"
                      [timeBlockers]="
                        (newBookingSlot.startMoment
                          | exec: generateTimeBlockersForDay
                          | async)!
                      "
                      [(ngModel)]="meetingRoomKioskBookingValue"
                      [timeFormat]="hourFormat$ | async"
                      [selectedUser]="null"
                      [meetingRoom]="meetingRoomData"
                      (meetingTimeRangeInputChange)="
                        meetingTimeRangeInputChangeHandler($event)
                      "
                    />
                  </div>
                  <div class="footer-controls">
                    <db-button
                      class="kiosk-high-button"
                      width="full-width"
                      severity="white"
                      buttonType="outlined"
                      (click)="onCancelBook()"
                      i18n="@@common|cancel"
                    >
                      Cancel
                    </db-button>
                    <db-button
                      class="kiosk-high-button"
                      width="full-width"
                      severity="white"
                      (click)="onConfirmCreateBooking()"
                      i18n="@@meeting-rooms-kiosk|confirm-booking"
                    >
                      Confirm booking
                    </db-button>
                  </div>
                </div>
              </div>
            }
          }
        </div>
      }
    }
  </ng-container>
</div>
